<template>
  <MainLayout>
    <div class="parallax" data-parallax data-parallax-speed="0.25" data-parallax-direction="down">
      <div class="relative w-screen">
        <img
          class="absolute -left-[1vw] top-[-12vh] w-[20vw] opacity-80"
          src="/images/bg-visual-left-top.webp"
          alt="" />
        <img
          class="absolute -right-[6vw] top-[18vh] w-[30vw] opacity-60"
          src="/images/bg-visual-right-top.webp"
          alt="" />
      </div>
    </div>

    <section id="hero" class="max-w-[1080px] lg:m-[auto]">
      <div class="flex items-center lg:mt-[4rem] lg:-mb-[5rem]">
        <div class="flex flex-col gap-y-4.5 lg:gap-y-8">
          <h1
            class="text-[32px] leading-[36px] lg:text-[70px] lg:leading-[74px] font-bold text-dark text-center font-markPro lg:max-w-[20ch] tracking-[-0.1rem]">
            {{ t('pages.info.faq.hero.heading.1') }}
            <span class="text-gradient-primary whitespace-nowrap">{{
              t('pages.info.faq.hero.heading.2')
            }}</span>
            {{ t('pages.info.faq.hero.heading.3') }}
          </h1>

          <div
            class="flex flex-col gap-6 text-center leading-[27px] lg:text-lg font-semibold max-w-[840px] m-auto">
            <p class="text-dark">{{ t('pages.info.faq.hero.description.1') }}</p>
            <p class="text-lighter">{{ t('pages.info.faq.hero.description.2') }}</p>
          </div>
        </div>
      </div>
    </section>

    <section id="faq" class="max-md:-mt-10">
      <div class="flex flex-col w-full max-w-[800px] gap-4">
        <div class="faq-item">
          <p class="title">{{ t('pages.info.faq.questions.1.question') }}</p>
          <div class="content text-lighter border-t border-t-[#ECEDF0] mt-4 pt-6 pb-2">
            {{ t('pages.info.faq.questions.1.answer') }}<br /><br />
            <b>{{ t('pages.info.faq.questions.1.bullet_title') }}</b>
            <br /><br />
            <ul class="list-disc pl-6">
              <li>{{ t('pages.info.faq.questions.1.bullets.1') }}</li>
              <li>{{ t('pages.info.faq.questions.1.bullets.2') }}</li>
              <li>{{ t('pages.info.faq.questions.1.bullets.3') }}</li>
            </ul>
            <br />
            <b>{{ t('pages.info.faq.questions.1.how') }}</b>
            <br /><br />
            <ol class="list-decimal pl-6">
              <li>{{ t('pages.info.faq.questions.1.list.1') }}</li>
              <li>{{ t('pages.info.faq.questions.1.list.2') }}</li>
              <li>{{ t('pages.info.faq.questions.1.list.3') }}</li>
            </ol>
          </div>
        </div>
        <div class="faq-item">
          <p class="title">{{ t('pages.info.faq.questions.2.question') }}</p>
          <div class="content text-lighter border-t border-t-[#ECEDF0] mt-4 pt-6 pb-2">
            {{ t('pages.info.faq.questions.2.answer') }}<br /><br />
            <b>{{ t('pages.info.faq.questions.2.how') }}</b>
            <br /><br />
            <ul class="list-disc pl-6">
              <li>{{ t('pages.info.faq.questions.2.bullets.1') }}</li>
              <li>{{ t('pages.info.faq.questions.2.bullets.2') }}</li>
              <li>{{ t('pages.info.faq.questions.2.bullets.3') }}</li>
              <li>{{ t('pages.info.faq.questions.2.bullets.4') }}</li>
              <li>{{ t('pages.info.faq.questions.2.bullets.5') }}</li>
            </ul>
            <br />
            <b>{{ t('pages.info.faq.questions.2.why') }}</b>
            <br /><br />
            {{ t('pages.info.faq.questions.2.why_answer') }}
          </div>
        </div>
        <div class="faq-item">
          <p class="title">{{ t('pages.info.faq.questions.3.question') }}</p>
          <div class="content text-lighter border-t border-t-[#ECEDF0] mt-4 pt-6 pb-2">
            {{ t('pages.info.faq.questions.3.answer') }}<br /><br />
            <b>{{ t('pages.info.faq.questions.3.what') }}</b>
            <br /><br />
            <ul class="list-disc pl-6">
              <li>{{ t('pages.info.faq.questions.3.bullets.1') }}</li>
              <li>{{ t('pages.info.faq.questions.3.bullets.2') }}</li>
              <li>{{ t('pages.info.faq.questions.3.bullets.3') }}</li>
              <li>{{ t('pages.info.faq.questions.3.bullets.4') }}</li>
            </ul>
          </div>
        </div>
        <div class="faq-item">
          <p class="title">{{ t('pages.info.faq.questions.4.question') }}</p>
          <div class="content text-lighter border-t border-t-[#ECEDF0] mt-4 pt-6 pb-2">
            {{ t('pages.info.faq.questions.4.answer.1') }}<br /><br />
            {{ t('pages.info.faq.questions.4.answer.2') }}
          </div>
        </div>
        <div class="faq-item">
          <p class="title">{{ t('pages.info.faq.questions.5.question') }}</p>
          <div class="content text-lighter border-t border-t-[#ECEDF0] mt-4 pt-6 pb-2">
            {{ t('pages.info.faq.questions.5.answer.1') }}<br /><br />
            <ul class="list-disc pl-6">
              <li>{{ t('pages.info.faq.questions.5.bullets.1') }}</li>
              <li>{{ t('pages.info.faq.questions.5.bullets.2') }}</li>
              <li>{{ t('pages.info.faq.questions.5.bullets.3') }}</li>
            </ul>
            <br />
            {{ t('pages.info.faq.questions.5.answer.2') }}
          </div>
        </div>
        <div class="faq-item">
          <p class="title">{{ t('pages.info.faq.questions.6.question') }}</p>
          <div class="content text-lighter border-t border-t-[#ECEDF0] mt-4 pt-6 pb-2">
            {{ t('pages.info.faq.questions.6.answer.1') }}<br /><br />
            {{ t('pages.info.faq.questions.6.answer.2') }}<br /><br />
            {{ t('pages.info.faq.questions.6.answer.3') }}<br /><br />
            <ul class="list-disc pl-6">
              <li>{{ t('pages.info.faq.questions.6.bullets.1') }}</li>
              <li>{{ t('pages.info.faq.questions.6.bullets.2') }}</li>
              <li>{{ t('pages.info.faq.questions.6.bullets.3') }}</li>
            </ul>
            <br />
            <b>{{ t('pages.info.faq.questions.6.answer.4') }}</b>
          </div>
        </div>
        <div class="faq-item">
          <p class="title">{{ t('pages.info.faq.questions.7.question') }}</p>
          <div class="content text-lighter border-t border-t-[#ECEDF0] mt-4 pt-6 pb-2">
            {{ t('pages.info.faq.questions.7.answer.1') }}<br /><br />
            {{ t('pages.info.faq.questions.7.answer.2') }}
          </div>
        </div>
        <div class="faq-item">
          <p class="title">{{ t('pages.info.faq.questions.8.question') }}</p>
          <div class="content text-lighter border-t border-t-[#ECEDF0] mt-4 pt-6 pb-2">
            {{ t('pages.info.faq.questions.8.answer') }}
          </div>
        </div>
        <div class="faq-item">
          <p class="title">{{ t('pages.info.faq.questions.9.question') }}</p>
          <div class="content text-lighter border-t border-t-[#ECEDF0] mt-4 pt-6 pb-2">
            {{ t('pages.info.faq.questions.9.answer') }}
          </div>
        </div>
        <div class="faq-item">
          <p class="title">{{ t('pages.info.faq.questions.10.question') }}</p>
          <div class="content text-lighter border-t border-t-[#ECEDF0] mt-4 pt-6 pb-2">
            {{ t('pages.info.faq.questions.10.answer.1') }}<br /><br />
            {{ t('pages.info.faq.questions.10.answer.2') }}<br /><br />
            {{ t('pages.info.faq.questions.10.answer.3') }}<br /><br />
            {{ t('pages.info.faq.questions.10.answer.4') }}<br /><br />
          </div>
        </div>
        <div class="faq-item">
          <p class="title">{{ t('pages.info.faq.questions.11.question') }}</p>
          <div class="content text-lighter border-t border-t-[#ECEDF0] mt-4 pt-6 pb-2">
            {{ t('pages.info.faq.questions.11.answer') }}
          </div>
        </div>
        <div class="faq-item">
          <p class="title">{{ t('pages.info.faq.questions.12.question') }}</p>
          <div class="content text-lighter border-t border-t-[#ECEDF0] mt-4 pt-6 pb-2">
            {{ t('pages.info.faq.questions.12.answer') }}
          </div>
        </div>

        <template v-for="id in 96" :key="id">
          <div v-if="id > 14 && ![25, 89, 93].includes(id)" class="faq-item">
            <p class="title">
              {{ t(`pages.info.faq.questions.${id}.question`) }}
            </p>
            <div class="content text-lighter border-t border-t-[#ECEDF0] mt-4 pt-6 pb-2">
              {{ t(`pages.info.faq.questions.${id}.answer`) }}
            </div>
          </div>
        </template>
      </div>
    </section>

    <section id="cta" class="backgroundgradient backgroundgradient-bottom">
      <div class="w-full rounded-2xl py-16 max-md:px-14 lg:pt-26 lg:pb-20 relative overflow-hidden">
        <div class="absolute inset-0 z-10 bg-[#E3EEF7]"></div>
        <div
          class="parallax"
          data-parallax
          data-parallax-speed="0.05"
          data-parallax-direction="down">
          <div class="relative w-full h-full">
            <img
              class="absolute top-0 left-0 -translate-x-1/3 h-[150%] rotate-[45%]"
              src="/images/bg-visual-left-top.webp"
              alt="" />

            <img
              class="absolute right-0 translate-x-1/3 -top-1/4 lg:-top-1/2 h-1/2 lg:h-full rotate-[-20deg]"
              src="/images/bg-visual-right-top.webp"
              alt="" />
          </div>
        </div>

        <div
          class="flex flex-col gap-y-5.5 justify-center items-center text-center relative z-30 lg:min-w-[1136px]">
          <h4
            class="text-[32px] leading-[42px] lg:text-5xl font-bold text-dark text-center font-markPro block tracking-[-0.08rem]">
            {{ t('main.cta_block.open_your_webshop_today') }}
            <span class="text-gradient-primary whitespace-nowrap">
              {{ t('main.cta_block.its_free') }}
            </span>
          </h4>

          <p class="text-lg lg:text-[24px] text-lighter font-semibold">
            {{ t('main.cta_block.start_generating_more_orders') }}
          </p>

          <a
            v-track-event="'onboarding_start'"
            href="https://merchant.bistroo.nl/register"
            class="btn btn-lg btn-primary flex items-center gap-x-3 mt-4">
            <span>
              {{ t('main.cta_block.get_started_for_free') }}
            </span>
            <i class="bi bi-arrow-right text-lg mt-[3px]"></i>
          </a>
        </div>
      </div>
    </section>
  </MainLayout>
</template>

<script setup lang="ts">
import MainLayout from '@/layouts/MainLayout.vue'
import { useHead } from '@unhead/vue'
import { onMounted } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

useHead(() => ({
  title: t('pages.info.faq.seo.title'),
  meta: [{ name: 'description', content: t('pages.info.faq.seo.description') }],
  script: [
    {
      type: 'application/ld+json',
      children: JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: [
          // Q1 – complex answer flattened
          {
            '@type': 'Question',
            name: t('pages.info.faq.questions.1.question'),
            acceptedAnswer: {
              '@type': 'Answer',
              text: [
                t('pages.info.faq.questions.1.answer'),
                t('pages.info.faq.questions.1.bullet_title'),
                t('pages.info.faq.questions.1.bullets.1'),
                t('pages.info.faq.questions.1.bullets.2'),
                t('pages.info.faq.questions.1.bullets.3'),
                t('pages.info.faq.questions.1.how'),
                t('pages.info.faq.questions.1.list.1'),
                t('pages.info.faq.questions.1.list.2'),
                t('pages.info.faq.questions.1.list.3'),
              ].join(' '),
            },
          },
          // Q2
          {
            '@type': 'Question',
            name: t('pages.info.faq.questions.2.question'),
            acceptedAnswer: {
              '@type': 'Answer',
              text: [
                t('pages.info.faq.questions.2.answer'),
                t('pages.info.faq.questions.2.bullets.1'),
                t('pages.info.faq.questions.2.bullets.2'),
                t('pages.info.faq.questions.2.bullets.3'),
                t('pages.info.faq.questions.2.bullets.4'),
                t('pages.info.faq.questions.2.bullets.5'),
                t('pages.info.faq.questions.2.why_answer'),
              ].join(' '),
            },
          },
          // Q3
          {
            '@type': 'Question',
            name: t('pages.info.faq.questions.3.question'),
            acceptedAnswer: {
              '@type': 'Answer',
              text: [
                t('pages.info.faq.questions.3.answer'),
                t('pages.info.faq.questions.3.bullets.1'),
                t('pages.info.faq.questions.3.bullets.2'),
                t('pages.info.faq.questions.3.bullets.3'),
                t('pages.info.faq.questions.3.bullets.4'),
              ].join(' '),
            },
          },
          // Q4
          {
            '@type': 'Question',
            name: t('pages.info.faq.questions.4.question'),
            acceptedAnswer: {
              '@type': 'Answer',
              text: [t('pages.info.faq.questions.4.answer.1'), t('pages.info.faq.questions.4.answer.2')].join(' '),
            },
          },
          // Q5
          {
            '@type': 'Question',
            name: t('pages.info.faq.questions.5.question'),
            acceptedAnswer: {
              '@type': 'Answer',
              text: [
                t('pages.info.faq.questions.5.answer.1'),
                t('pages.info.faq.questions.5.bullets.1'),
                t('pages.info.faq.questions.5.bullets.2'),
                t('pages.info.faq.questions.5.bullets.3'),
                t('pages.info.faq.questions.5.answer.2'),
              ].join(' '),
            },
          },
          // Q6
          {
            '@type': 'Question',
            name: t('pages.info.faq.questions.6.question'),
            acceptedAnswer: {
              '@type': 'Answer',
              text: [
                t('pages.info.faq.questions.6.answer.1'),
                t('pages.info.faq.questions.6.answer.2'),
                t('pages.info.faq.questions.6.answer.3'),
                t('pages.info.faq.questions.6.bullets.1'),
                t('pages.info.faq.questions.6.bullets.2'),
                t('pages.info.faq.questions.6.bullets.3'),
                t('pages.info.faq.questions.6.answer.4'),
              ].join(' '),
            },
          },
          // Q7
          {
            '@type': 'Question',
            name: t('pages.info.faq.questions.7.question'),
            acceptedAnswer: {
              '@type': 'Answer',
              text: [t('pages.info.faq.questions.7.answer.1'), t('pages.info.faq.questions.7.answer.2')].join(' '),
            },
          },
          // Q8–Q12: simple answers
          ...[8, 9, 11, 12].map((id) => ({
            '@type': 'Question',
            name: t(`pages.info.faq.questions.${id}.question`),
            acceptedAnswer: { '@type': 'Answer', text: t(`pages.info.faq.questions.${id}.answer`) },
          })),
          // Q10 – multi-part answer
          {
            '@type': 'Question',
            name: t('pages.info.faq.questions.10.question'),
            acceptedAnswer: {
              '@type': 'Answer',
              text: [
                t('pages.info.faq.questions.10.answer.1'),
                t('pages.info.faq.questions.10.answer.2'),
                t('pages.info.faq.questions.10.answer.3'),
                t('pages.info.faq.questions.10.answer.4'),
              ].join(' '),
            },
          },
          // Q15–Q96 (simple answers, skip removed ids 25, 89, 93)
          ...[15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36,
            37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57,
            58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78,
            79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 90, 91, 92, 94, 95, 96].map((id) => ({
            '@type': 'Question',
            name: t(`pages.info.faq.questions.${id}.question`),
            acceptedAnswer: { '@type': 'Answer', text: t(`pages.info.faq.questions.${id}.answer`) },
          })),
        ],
      }),
    },
  ],
}))

onMounted(() => {
  const elements = document.querySelectorAll('.faq-item')

  elements.forEach((el) => {
    el.addEventListener('click', (e: Event) => {
      e.preventDefault()

      const isCollapsed = el.classList.contains('active')

      document.querySelectorAll('.active').forEach((el) => {
        el.classList.remove('active')
      })

      el.classList.toggle('active', !isCollapsed)
    })
  })
})
</script>

<style scoped>
@reference "@/assets/css/main.css";

.faq-item {
  @apply relative p-6 !pr-16 bg-white rounded-xl drop-shadow;
  cursor: pointer;

  .title {
    @apply text-lighter font-semibold;
  }

  .content {
    display: none;
  }

  &::after {
    position: absolute;
    right: 1.5rem;
    top: 1.5rem;
    content: '';
    width: 24px;
    height: 24px;
    background: url(/images/ico-plus.svg);
  }

  &.active {
    .title {
      @apply text-gradient-primary;
    }

    .content {
      display: block;
    }

    &::after {
      top: 1.4rem;
      background: url(/images/ico-min.svg);
    }
  }
}
</style>
